<script>
    export default {
        name: 'OutlineIcon',
        props: {
            width: {
                type: [Number, String],
                required: false,
                default: 24,
            },
            height: {
                type: [Number, String],
                required: false,
                default: 24,
            },
        },
    };
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" class="fill-current">
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path
            d="M19 5v4H4V5h15m0 10v4H4v-4h15m1-12H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm0 10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1z" />
    </svg>
</template>
